module.exports = __webpack_public_path__ + "media/images/front/top/emgality-cdd9dcc745f30d47b7fb3742c833ecba.jpg";